module.exports = __webpack_public_path__ + "img/pink.70d5d379.png";